/* ============================================================
   Fashion City — 커스텀 상품 최소 주문 수량
   수량칸이 최소값에서 시작하고 1씩 올라가며,
   그 아래로는 내려가지 않게 막습니다.

   상품을 추가하거나 최소수량을 바꾸려면 아래 RULES만 고치세요.
   '상품주소(handle)': 최소수량
   ============================================================ */
(function () {
  var RULES = {
    'custom-sweatshirt-your-design': 6,          // 스웿셔츠 (Gildan 18000)
    'custom-hoodie-your-design': 6,              // 후디
    't-shirt': 6,                                // (예비)
    'custom-t-shirt-your-design': 6,             // 티셔츠
    'custom-baseball-cap-your-design': 24,       // 베이스볼칧7
    'custom-two-tone-trucker-hat-your-design': 24, // 투톤 트러커햇
    'custom-cotton-tote-bag-your-design': 12     // 코튼 가방
  };

  var SELECTOR = [
    'input[name="quantity"]',
    'input[data-quantity-input]',
    'quantity-input input[type="number"]',
    '.quantity-input input',
    '.quantity-selector input',
    'input.js-qty__num'
  ].join(',');

  var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
  if (!m) return;
  var min = RULES[m[1]];
  if (!min) return;

  function clamp(input) {
    var v = parseInt(input.value, 10);
    if (isNaN(v) || v < min) {
      input.value = min;
      try { input.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
    }
  }

  function apply() {
    var inputs = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (input.dataset.fcQtyInit) continue;
      input.dataset.fcQtyInit = '1';
      input.setAttribute('min', min);
      input.setAttribute('step', '1');
      clamp(input);
      input.addEventListener('change', function () { clamp(this); });
      input.addEventListener('blur', function () { clamp(this); });
      var wrap = input.closest('.quantity-input, quantity-input, .quantity-selector, form') || input.parentNode;
      if (wrap && !wrap.dataset.fcQtyBound) {
        wrap.dataset.fcQtyBound = '1';
        wrap.addEventListener('click', (function (el) {
          return function () { setTimeout(function () { clamp(el); }, 40); };
        })(input));
      }
    }
  }

  function boot() {
    apply();
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; apply(); }, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
